import React from 'react';
import {
    Responsive,
    SimpleList,
    TextField,
    SimpleForm,
    TextInput,
    DisabledInput,
    LongTextInput,
    required,
} from 'admin-on-rest';
import List from '../admin/List';
import Edit from '../admin/Edit';
import DatagridWithContentRow from '../admin/DatagridWithContentRow';
import EditButton from '../buttons/EditButtonByCustomKey';
import TooltipIcon from '../components/TooltipIcon';
import ReactTooltip from 'react-tooltip';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/settings';

export const fuseConfigurationIcon = Icon;

/*
 * View: List
 */

// Set title for List Configurations
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>Configurations</span>;

const ListDescription = () => {
    return (
        <span>
            <p>Configurations are pairs of keys and values that dictate how the POS System treats certain features.
                Currently Configurations are devoted to Loyalty Accounts.</p>
        </span>
    );
};

export const fuseConfigurationList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>}
          sort={{field: 'name', order: 'ASC'}}
          perPage={15}
    >
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => record.value}
                />
            }
            medium={
                <DatagridWithContentRow
                    bodyOptions={{stripedRows: false, showRowHover: true}}
                    columns={3}
                    contentKey="description"
                    uniqueKey="name"
                >
                    <TextField source="name" label="Name"/>
                    <TextField source="value" label="Value"/>
                    <EditButton customKey="name"/>
                </DatagridWithContentRow>
            }
        />
    </List>
);

export const fuseConfigurationListViewOnly = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>}
          sort={{field: 'name', order: 'ASC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => record.value}
                />
            }
            medium={
                <DatagridWithContentRow
                    bodyOptions={{stripedRows: false, showRowHover: true}}
                    columns={3}
                    contentKey="description"
                    uniqueKey="name"
                >
                    <TextField source="name" label="Name"/>
                    <TextField source="value" label="Value"/>
                </DatagridWithContentRow>
            }
        />
    </List>
);

/*
 * View: Edit form
 */

// Set title for Edit Configuration
const EditTitle = ({record}) => {
    return <span><Avatar icon={<Icon/>} style={viewStyles.avatar}
                         className="avatar-title"/>Edit {record ? `${record.name}` : 'Configuration'}</span>;
};

const EditDescription = () => {
    return (
        <span>
            <p>Modify value or description fields below. Click <strong>Save</strong> to store this Configuration.</p>
        </span>
    );
};

/*
 * Edit System Configuration form
 */
export const fuseSystemConfigurationEdit = (props) => (
    <Edit {...props} title={<EditTitle/>} desc={<EditDescription/>}>
        <SimpleForm>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
            <span style={viewStyles.fieldDescriptionTop}>
                The <strong>Name</strong> of the Configuration (cannot be edited).
                <TooltipIcon dataFor="ttName"/>
                <ReactTooltip id="ttName" type="light" effect="solid" multiline={true} border={true} className="tooltip">
                    The POS refers to Configurations for Loyalty settings, messaging, and other variables. Not every
                    store will need custom Configurations.
                </ReactTooltip>
            </span>
            <DisabledInput source="name" label="" elStyle={viewStyles.noPaddingTop}/>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>

            <TextInput source="value" label="Value" validate={[required]}/>
            <span style={viewStyles.fieldDescription}>
                The <strong>Value</strong> of this Configuration.
                <TooltipIcon dataFor="ttValue"/>
                <ReactTooltip id="ttValue" type="light" effect="solid" multiline={true} border={true} className="tooltip">
                    Depending on the Configuration, the <strong>Value</strong> may be a number or string.
                </ReactTooltip>
            </span>

            <LongTextInput source="description" label="Description" elStyle={viewStyles.fieldMultiline}/>
            <span style={viewStyles.fieldDescription}>
                The <strong>Description</strong> of this Configuration.
                <TooltipIcon dataFor="ttDesc"/>
                <ReactTooltip id="ttDesc" type="light" effect="solid" multiline={true} border={true} className="tooltip">
                    The <strong>Description</strong> may include formulas or variables the POS checks against.
                </ReactTooltip>
            </span>

            <span style={viewStyles.fieldInstructions}>
                    After clicking <strong>Save</strong>, you will be redirected to the list of System Configurations.
                </span>
            <hr style={{...viewStyles.break, ...viewStyles.paddingBottom}}/>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/Fuse/Setting/configuration.js